<div class="contacts-directory">
  <directory-list
    *ngIf="!selectedDirectory; else valuesListTmp"
    (selectDirectory)="changeSelectedDirectory($event)"
  ></directory-list>

  <ng-template #valuesListTmp>
    <values-list [selectedDirectory]="selectedDirectory" (return)="changeSelectedDirectory()"></values-list>
  </ng-template>
</div>
